<div [formGroup]="form">
  <input type="text"
         name="daterange"
         ngxDaterangepickerMd
         [showClearButton]="true"                  
         [locale]="calendarLocale" [placeholder]="field.placeholderText!"
         [id]="field.controlName"
         [formControlName]="field.controlName" (change)="onDateChange($event)" />
</div>
